export const MathRound = (num: number, places: number) => {
  if (!`${num}`.includes('e')) {
    return +`${Math.round(Number(`${num}e+${places}`))}e-${places}`;
  }
  const arr = `${num}`.split('e');

  let sig = '';

  if (+arr[1] + places > 0) {
    sig = '+';
  }

  return +`${Math.round(
    Number(`${+arr[0]}e${sig}${+arr[1] + places}`),
  )}e-${places}`;
};
